import shareDialog from './index.vue';
 
// 定义插件对象
const ShareDialog = {};
// vue的install方法，用于定义vue插件
ShareDialog.install = function (Vue, options) {
  const ShareDialogInstance = Vue.extend(shareDialog);
  let currentMsg;
  const initInstance = () => {
    // 实例化vue实例
    currentMsg = new ShareDialogInstance();
    let msgBoxEl = currentMsg.$mount().$el;
    document.body.appendChild(msgBoxEl);
  };
  // 在Vue的原型上添加实例方法，以全局调用
  Vue.prototype.$shareDialog = {
    showShareDialog (options) {
      if (!currentMsg) {
        initInstance();
      }
      if (typeof options === 'string') {
        currentMsg.content = options;
      } else if (typeof options === 'object') {
        Object.assign(currentMsg, options);
      }
      currentMsg.showMsgBox();
    }
  };
};
 
export default ShareDialog;


// WEBPACK FOOTER //
// ./src/components/common/share-dialog/index.js